import { createSlice } from '@reduxjs/toolkit';

const slice = createSlice({
  name: 'resumeStats',
  initialState: {
    data: {
      resume: {
        active_students: 0,
        active_teachers: 0,
        registered_students: 0,
        registered_teachers: 0,
        total_classes: 0,
        total_students_usage_time: 0,
        total_teachers_usage_time: 0,
        total_centers: 0,
      },
    },
  },
  reducers: {
    setResume: (state, { payload: obj }) => {
      state.data.resume = obj;
    },
  },
});

export const { setResume } = slice.actions;

export default slice.reducer;

export const selectResume = (state) => state.resumeStats.data.resume;
